let URL = 'http://www.lvh.me/services/cart/api/v1/cart/products/448/'

export function compressed({quantity, 1: urlForSide1, 2: urlForSide2}) {
  return [quantity, idFromProductUrl(urlForSide1), idFromProductUrl(urlForSide2)].join(',');
}

export function expanded(selectedProductString) {
  if (!selectedProductString) return null;
  if (typeof selectedProductString === 'object') return validateProductSelector(selectedProductString);
  let [quantity, id1, id2] = selectedProductString.split(',');
  return {quantity: +quantity, 1: urlFromProductId(id1), 2: urlFromProductId(id2)}
}

function validateProductSelector({quantity, 1: urlForSide1, 2: urlForSide2}) {
  if (!Number.isInteger(+quantity) || !(urlForSide1 || urlForSide2)) throw new Error('invalid selector');
  return {quantity, 1: urlForSide1, 2: urlForSide2};
}

/**
 * Return URL from id encoded by idFromProductUrl. ALways return www.brandly.com, regardless
 * of environment, as all backends accept that format.
 *
 * @param {*} id
 */
function urlFromProductId(id) {
  return id ? `https://www.brandly.com/services/cart/api/v1/cart/products/${id}/` : null;
}

/**
 * Return an id as a string suitable to be encoded in a url.
 *
 * @param {*} url
 */
export function idFromProductUrl(url) {
  if (!url) return '';
  let m = /\/products\/(\d+)\//.exec(url);
  if (!m) throw new Error("Invalid URL");
  return m[1];
}



// WEBPACK FOOTER //
// ./src/lib/selectedProduct.js